import { FC } from 'react';

interface Props {
  xAxis: number;
  yAxis?: number;
  transparency: number;
}

const PlayButton: FC<Props> = ({ xAxis, yAxis = -9, transparency }) => {
  return (
    <svg
      style={{
        position: 'relative',
        bottom: '78px',
        zIndex: '2',
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="80"
      viewBox={`${xAxis} ${yAxis} 32 32`}
    >
      <path
        fill={`rgba(0, 145, 220, ${transparency})`}
        d="M8 1a7 7 0 11-7 7 7 7 0 017-7zm0-1a8 8 0 108 8 8 8 0 00-8-8z"
      ></path>
      <path
        fill={`rgba(0, 145, 220, ${transparency})`}
        d="M8 2a6 6 0 106 6 6 6 0 00-6-6zm-1 8.328V5.671l3.828 2.328z"
      ></path>
    </svg>
  );
};

export default PlayButton;
